var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"property-wrapper res-no-border"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h2',[_vm._v(_vm._s(_vm.$t('PAYMENT_GATEWAYS')))])]),_c('payment-gateway-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }